var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPropisiPoKlasterima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 31.119 31.119",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.065,14.984c-0.1-0.666-0.671-1.146-1.343-1.146H13.836l-1.977-2.34c-0.419-0.492-1.034-0.802-1.681-0.802H3.105 c-0.504,0-0.983,0.236-1.309,0.622c-0.325,0.387-0.464,0.917-0.379,1.414l0.188,1.106H1.481c-0.396,0-0.771,0.161-1.027,0.461 c-0.26,0.301-0.373,0.693-0.312,1.084l2.196,14.248c0.133,0.857,0.871,1.488,1.738,1.488h22.797c0.396,0,0.771-0.174,1.027-0.471 c0.257-0.3,0.373-0.689,0.314-1.08L26.065,14.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.645,4.351H12.13c-0.587,0-1.063,0.53-1.063,1.118s0.477,1.118,1.063,1.118h8.515c0.589,0,1.064-0.53,1.064-1.118 S21.232,4.351,20.645,4.351z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.677,12.186c-0.245-0.285-0.604-0.464-0.981-0.464h-2.416l0.55,5.095l1.313,8.901l1.838-12.492 C31.032,12.854,30.924,12.472,30.677,12.186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.024,2.055h14.864v10.091h2.056V1.307C25.943,0.591,25.345,0,24.629,0H8.191C7.405,0,6.789,0.647,6.789,1.433v7.812 h2.235V2.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.645,8.46H12.13c-0.511,0-0.937,0.404-1.04,0.899c0.729,0.186,1.392,0.583,1.891,1.168l0.155,0.168h7.509 c0.589,0,1.064-0.53,1.064-1.118C21.709,8.989,21.232,8.46,20.645,8.46z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropisiPoKlasterima);
export default __webpack_public_path__ + "static/media/PropisiPoKlasterima.59c61f06ca2d8fdb065918433b4f474e.svg";
export { ForwardRef as ReactComponent };